// Trident が含まれていれば IE
const isInternetExplorer = (ua: string): boolean => {
  return /Trident/i.test(ua);
};

export { isInternetExplorer };
